<script setup>
import { ref } from 'vue';

const steps = ref([
  'services-page.body.how.steps[0]',
  'services-page.body.how.steps[1]',
  'services-page.body.how.steps[2]',
  'services-page.body.how.steps[3]',
  'services-page.body.how.steps[4]',
]);
</script>

<template>
  <section class="how-we-work-section">
    <div class="container">
      <h2 class="section-title">{{ $t('services-page.body.how.title') }}</h2>
      <div class="steps-grid">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="step-card"
          data-aos="fade-up"
          :data-aos-delay="index * 100"
        >
          <div class="step-number">{{ '0' + (index + 1) }}</div>
          <p class="step-text">{{ $t(step) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.how-we-work-section {
  background-color: #eef3fb;
  padding: 6rem 5%;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
}
.section-title {
  font-family: 'Poppins', sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  color: #0a2d61;
  text-align: center;
  margin-bottom: 4rem;
  text-transform: uppercase;
}
.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
}
.step-card {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}
.step-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #fcbc0d;
  margin-bottom: 1rem;
}
.step-text {
  color: #555;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}
</style>